export default __webpack_public_path__ + "static/media/Return@3x.ea93e767.png";